import { createContext, useState, useContext, useEffect } from 'react';

const CctvContext = createContext();

export function CctvProvider({ children }) {
  // localStorage에서 저장된 데이터 불러오기
  const [activeCctvs, setActiveCctvs] = useState(() => {
    const savedCctvs = localStorage.getItem('activeCctvs');
    return savedCctvs ? JSON.parse(savedCctvs) : {};
  });
  
  // activeCctvs가 변경될 때마다 localStorage에 저장
  useEffect(() => {
    localStorage.setItem('activeCctvs', JSON.stringify(activeCctvs));
    //console.log('CCTV 컨텍스트 업데이트됨:', activeCctvs);
  }, [activeCctvs]);

  const updateActiveCctv = (cctvInfo) => {
    console.log('updateActiveCctv 호출됨:', cctvInfo);
    
    // 타임스탬프 추가
    const updatedCctvInfo = {
      ...cctvInfo,
      timestamp: Date.now()
    };
    
    setActiveCctvs(prev => {
      const updated = {
        ...prev,
        [cctvInfo.id]: updatedCctvInfo
      };
      console.log('업데이트된 activeCctvs:', updated);
      return updated;
    });
  };
  
  // 디버깅용 - 컨텍스트 값 확인
  useEffect(() => {
    //console.log('CctvContext Provider 마운트됨');
    return () => console.log('CctvContext Provider 언마운트됨');
  }, []);

  return (
    <CctvContext.Provider value={{ activeCctvs, updateActiveCctv }}>
      {children}
    </CctvContext.Provider>
  );
}

export function useCctvContext() {
  const context = useContext(CctvContext);
  if (!context) {
    throw new Error('useCctvContext must be used within a CctvProvider');
  }
  return context;
}
